/**
 * WebView bridge helpers for native in-app purchases (Text2 mobile shell).
 * No-op in normal browser; active when ReactNativeWebView is injected.
 */

const hasNativeBridge = () =>
  typeof window !== 'undefined' &&
  window.ReactNativeWebView &&
  typeof window.ReactNativeWebView.postMessage === 'function';

export const isText2MobileApp = () => hasNativeBridge();

export const getNativeIapPlatform = () => {
  if (typeof window !== 'undefined' && window.text2Iap && window.text2Iap.platform) {
    return window.text2Iap.platform;
  }
  return null;
};

export const resolveStoreProductId = (pkg) => {
  const platform = getNativeIapPlatform();
  if (platform === 'ios') {
    return pkg.iosProductId || pkg.androidProductId;
  }
  if (platform === 'android') {
    return pkg.androidProductId || pkg.iosProductId;
  }
  return pkg.androidProductId || pkg.iosProductId;
};

export const purchaseRuhparasiPackageNative = (packageId, productId) => {
  if (!hasNativeBridge()) {
    return Promise.resolve({
      success: false,
      message: 'Mobil uygulama köprüsü bulunamadı',
    });
  }

  return new Promise((resolve) => {
    const timeout = window.setTimeout(() => {
      cleanup();
      resolve({ success: false, message: 'Satın alma zaman aşımına uğradı' });
    }, 120000);

    const listener = (event) => {
      const detail = event && event.detail;
      if (!detail || detail.type !== 'IAP_PURCHASE_RESULT') {
        return;
      }
      cleanup();
      resolve({
        success: Boolean(detail.success),
        message: detail.message || (detail.success ? 'Ruh parası yüklendi' : 'Satın alma başarısız'),
        packageId: detail.packageId,
        amount: detail.amount,
        ruhParasi: detail.ruhParasi,
        orderId: detail.orderId,
      });
    };

    const cleanup = () => {
      window.clearTimeout(timeout);
      window.removeEventListener('text2-native-iap', listener);
    };

    window.addEventListener('text2-native-iap', listener);

    if (window.text2Iap && typeof window.text2Iap.purchasePackage === 'function') {
      const started = window.text2Iap.purchasePackage(packageId, productId);
      if (!started) {
        cleanup();
        resolve({ success: false, message: 'Oturum bulunamadı' });
      }
      return;
    }

    const username = localStorage.getItem('username');
    const token = localStorage.getItem('token');
    if (!username || !token) {
      cleanup();
      resolve({ success: false, message: 'Oturum bulunamadı' });
      return;
    }

    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: 'IAP_PURCHASE',
        username,
        token,
        packageId,
        productId,
      }),
    );
  });
};

export const subscribeNativeIapEvents = (handler) => {
  if (typeof window === 'undefined') {
    return () => {};
  }
  const listener = (event) => {
    if (event && event.detail) {
      handler(event.detail);
    }
  };
  window.addEventListener('text2-native-iap', listener);
  return () => window.removeEventListener('text2-native-iap', listener);
};
